import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useMemberActivityTracking } from "../../hooks/useMemberActivityTracking";

export function SchoolLayoutRedirects() {

  const { currentMembership } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  const { trackActivity } = useMemberActivityTracking();

  useEffect(() => {

    if (location.pathname === `/school/${currentMembership?.school_id}` || location.pathname === `/school/${currentMembership?.school_id}/`) {
      if (currentMembership?.is_owner || currentMembership?.is_admin) {
        navigate('/school/' + currentMembership?.school_id + '/admin', { replace: true });
      } else if (currentMembership?.is_staff) {
        navigate('/school/' + currentMembership?.school_id + '/secretariat', { replace: true });
      } else if (currentMembership?.is_teacher) {
        navigate('/school/' + currentMembership?.school_id + '/teacher', { replace: true });
      }
    }
  }, [currentMembership, location.pathname, navigate])

  // Track member activity when redirects are processed
  useEffect(() => {
    if (currentMembership) {
      trackActivity(""); // Empty access token since we're using credentials: "include"
    }
  }, [currentMembership, trackActivity]);

  return (
    <Outlet />
  )
}